var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "layout" }, [
        _c("div", { staticClass: "layout__header" }, [
          _c("div", { staticClass: "layout__title" }, [
            _c("h3", [
              _vm._v("Guía de Remisión " + _vm._s(_vm.numero_comprobante))
            ]),
            _vm._v(" "),
            _c("label", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "PPR" && _vm.anulado === "N",
                      expression: "estado === 'PPR' && anulado === 'N'"
                    }
                  ],
                  staticClass: "noti-warning"
                },
                [_c("strong", [_vm._v("PENDIENTE DE AUTORIZACIÓN")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.anulado === "S",
                      expression: "anulado === 'S'"
                    }
                  ],
                  staticClass: "noti-danger"
                },
                [_c("strong", [_vm._v("ANULADO")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.estado === undefined || _vm.estado === null) &&
                        _vm.anulado === "N" &&
                        !_vm.enColaAutorizacion,
                      expression:
                        "(estado === undefined || estado === null) && anulado === 'N' && !enColaAutorizacion"
                    }
                  ],
                  staticClass: "noti-info"
                },
                [_c("strong", [_vm._v("EMITIDO")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "AUT" && _vm.anulado === "N",
                      expression: "estado === 'AUT' && anulado === 'N'"
                    }
                  ],
                  staticClass: "noti-success"
                },
                [_c("strong", [_vm._v("AUTORIZADO")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "N" && _vm.anulado === "N",
                      expression: "estado === 'N' && anulado === 'N'"
                    }
                  ],
                  staticClass: "noti-secondary"
                },
                [_c("strong", [_vm._v("NUEVO")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "NAT" && _vm.anulado === "N",
                      expression: "estado === 'NAT' && anulado === 'N'"
                    }
                  ],
                  staticClass: "noti-danger"
                },
                [_c("strong", [_vm._v("NO AUTORIZADO")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.enColaAutorizacion,
                      expression: "enColaAutorizacion"
                    }
                  ],
                  staticClass: "noti-primary"
                },
                [_c("strong", [_vm._v("PENDIENTE DE ENVÍO AL SRI")])]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "layout__controls" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: {
                  disabled:
                    !_vm.permiteAnularGuiaRemision &&
                    !_vm.permiteEditarGuiaRemision
                },
                on: {
                  click: function($event) {
                    return _vm.$modal.show("listaGuiasRemision")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main" }, [
          _c("div", { staticClass: "layout__main-form" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-field select2",
                            class: {
                              "select2--disabled":
                                !_vm.editable || _vm.id_comprobante !== ""
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.puntosEmision,
                                    label: "descripcion",
                                    id: "puntoEmision",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedPuntoEmision,
                                    callback: function($$v) {
                                      _vm.selectedPuntoEmision = $$v
                                    },
                                    expression: "selectedPuntoEmision"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "puntoEmision" } },
                                  [_vm._v("Punto de emisión")]
                                ),
                                _vm._v(" "),
                                _vm.errores.id_punto_emision
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.id_punto_emision[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "datepicker-field" },
                            [
                              _c("date-picker", {
                                attrs: {
                                  disabled: !_vm.editable,
                                  type: "date",
                                  format: "dd-MM-yyyy",
                                  id: "fecha_emision",
                                  lang: "es"
                                },
                                model: {
                                  value: _vm.form.fecha_emision,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_emision", $$v)
                                  },
                                  expression: "form.fecha_emision"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "fecha_emision" } }, [
                                _vm._v("Fecha de emisión")
                              ]),
                              _vm._v(" "),
                              _vm.errores.fecha_emision
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.fecha_emision[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    disabled: !_vm.editable,
                                    id: "numeroIdentificacion",
                                    placeholder: "Id transportista"
                                  },
                                  model: {
                                    value: _vm.numero_identificacion,
                                    callback: function($$v) {
                                      _vm.numero_identificacion = $$v
                                    },
                                    expression: "numero_identificacion"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Identificación del transportista")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.id_transportista
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.id_transportista[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.tieneTransportista,
                                      expression: "!tieneTransportista"
                                    }
                                  ],
                                  staticClass: "btn-success",
                                  attrs: {
                                    disabled: !_vm.editable,
                                    type: "button"
                                  },
                                  on: { click: _vm.consultarCliente }
                                },
                                [_c("i", { staticClass: "fa fa-check" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tieneTransportista,
                                      expression: "tieneTransportista"
                                    }
                                  ],
                                  staticClass: "btn-danger",
                                  attrs: {
                                    disabled: !_vm.editable,
                                    type: "button"
                                  },
                                  on: { click: _vm.quitarPersona }
                                },
                                [_c("i", { staticClass: "fa fa-ban" })]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "transportista",
                                    placeholder: "Escoja un transportista...",
                                    readonly: ""
                                  },
                                  model: {
                                    value: _vm.nombre_transportista,
                                    callback: function($$v) {
                                      _vm.nombre_transportista = $$v
                                    },
                                    expression: "nombre_transportista"
                                  }
                                },
                                [_c("span", [_vm._v("Transportista")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-info",
                                  attrs: {
                                    disabled: !_vm.editable,
                                    type: "button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$modal.show(
                                        "listaTransportistas"
                                      )
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-search" })]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "AAA####",
                                    expression: "'AAA####'"
                                  }
                                ],
                                attrs: {
                                  type: "tel",
                                  disabled: !_vm.editable,
                                  id: "placa",
                                  placeholder: "Placa"
                                },
                                model: {
                                  value: _vm.form.placa_transportista,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "placa_transportista",
                                      $$v
                                    )
                                  },
                                  expression: "form.placa_transportista"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                Placa de transportista\n                                                "
                                ),
                                _vm.errores.placa_transportista
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.placa_transportista[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  disabled: !_vm.editable,
                                  placeholder: "Escriba una dirección...",
                                  id: "direccionPartida"
                                },
                                model: {
                                  value: _vm.form.direccion_partida,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "direccion_partida", $$v)
                                  },
                                  expression: "form.direccion_partida"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                Dirección de partida\n                                                "
                                ),
                                _vm.errores.direccion_partida
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.direccion_partida[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "datepicker-field" },
                            [
                              _c("date-picker", {
                                attrs: {
                                  disabled: !_vm.editable,
                                  type: "date",
                                  format: "dd-MM-yyyy",
                                  id: "fecha_inicio",
                                  lang: "es"
                                },
                                model: {
                                  value: _vm.form.fecha_inicio_transporte,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "fecha_inicio_transporte",
                                      $$v
                                    )
                                  },
                                  expression: "form.fecha_inicio_transporte"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "fecha_inicio" } }, [
                                _vm._v("Fecha de inicio")
                              ]),
                              _vm._v(" "),
                              _vm.errores.fecha_inicio_transporte
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .fecha_inicio_transporte[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "datepicker-field" },
                            [
                              _c("date-picker", {
                                attrs: {
                                  disabled: !_vm.editable,
                                  type: "date",
                                  format: "dd-MM-yyyy",
                                  id: "fecha_fin",
                                  lang: "es"
                                },
                                model: {
                                  value: _vm.form.fecha_fin_transporte,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "fecha_fin_transporte",
                                      $$v
                                    )
                                  },
                                  expression: "form.fecha_fin_transporte"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "fecha_fin" } }, [
                                _vm._v("Fecha de fin")
                              ]),
                              _vm._v(" "),
                              _vm.errores.fecha_fin_transporte
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.fecha_fin_transporte[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  disabled: !_vm.editable,
                                  id: "email",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                E-mail\n                                                "
                                ),
                                _vm.errores.email
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.email[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: { id: "clave_acceso", readonly: "" },
                                model: {
                                  value: _vm.clave_acceso,
                                  callback: function($$v) {
                                    _vm.clave_acceso = $$v
                                  },
                                  expression: "clave_acceso"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                Clave de acceso\n                                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  readonly: "",
                                  id: "numero_autorizacion"
                                },
                                model: {
                                  value: _vm.form.numero_autorizacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "numero_autorizacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.numero_autorizacion"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                Número de autorización\n                                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  readonly: "",
                                  id: "fecha_autorizacion"
                                },
                                model: {
                                  value: _vm.form.fecha_autorizacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "fecha_autorizacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.fecha_autorizacion"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                                Fecha de autorización\n                                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card__content" },
                    [
                      _c("tabla-informacion-adicional", {
                        attrs: {
                          disabled: !_vm.editable,
                          errores: _vm.errores
                        },
                        model: {
                          value: _vm.form.informacionAdicional,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "informacionAdicional", $$v)
                          },
                          expression: "form.informacionAdicional"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12" },
                        [
                          _c("tabla-detalle-guia-remision", {
                            attrs: { disabled: !_vm.editable },
                            on: {
                              personaActualizada: _vm.personaActualizada,
                              personaEliminada: _vm.personaEliminada,
                              personaSeleccionada: _vm.personaSeleccionada
                            },
                            model: {
                              value: _vm.form.detalles,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "detalles", $$v)
                              },
                              expression: "form.detalles"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "layout__main-buttons" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__content" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado !== "PPR" && _vm.anulado !== "S",
                        expression: "estado !== 'PPR' && anulado !== 'S'"
                      }
                    ],
                    staticClass: "btn-success",
                    attrs: {
                      disabled:
                        (_vm.estado === "N" && !_vm.permiteCrearGuiaRemision) ||
                        (_vm.estado !== "N" && !_vm.permiteEditarGuiaRemision),
                      type: "button"
                    },
                    on: { click: _vm.guardarComprobante }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guardar")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-light btn--text",
                    attrs: {
                      disabled: !_vm.permiteCrearGuiaRemision,
                      type: "button"
                    },
                    on: { click: _vm.nuevoComprobante }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Nuevo")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado !== "N" && _vm.anulado === "N",
                        expression: "estado !== 'N' && anulado === 'N'"
                      }
                    ],
                    staticClass: "btn-danger btn--text",
                    attrs: {
                      disabled: !_vm.permiteAnularGuiaRemision,
                      type: "button"
                    },
                    on: { click: _vm.anularComprobante }
                  },
                  [
                    _c("i", { staticClass: "fa fa-ban" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Anular")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado !== "N",
                        expression: "estado !== 'N'"
                      }
                    ],
                    staticClass: "btn-bus200 btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.imprimirComprobante }
                  },
                  [
                    _c("i", { staticClass: "fa fa-print" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Imprimir")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.enColaAutorizacion &&
                          _vm.esElectronico &&
                          _vm.estado !== "AUT" &&
                          _vm.estado !== "N" &&
                          _vm.anulado === "N" &&
                          _vm.permiteAutorizarGuiaRemision,
                        expression:
                          "!enColaAutorizacion && esElectronico && estado !== 'AUT' && estado !== 'N' && anulado === 'N' && permiteAutorizarGuiaRemision"
                      }
                    ],
                    staticClass: "btn-primary btn--text",
                    on: { click: _vm.autorizar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-paper-plane" }),
                    _c("span", [_vm._v("Autorizar")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado === "AUT",
                        expression: "estado === 'AUT'"
                      }
                    ],
                    staticClass: "btn-info btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.enviarCorreo }
                  },
                  [
                    _c("i", { staticClass: "fa fa-envelope-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Enviar correo")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado !== "N" && _vm.esElectronico,
                        expression: "estado !== 'N' && esElectronico"
                      }
                    ],
                    staticClass: "btn-secondary btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.abrirLogs }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Logs")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-secondary btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.verAnterior }
                  },
                  [
                    _c("i", { staticClass: "fa fa-toggle-left" }),
                    _c("span", [_vm._v("Anterior")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-secondary btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.verSiguiente }
                  },
                  [
                    _c("i", { staticClass: "fa fa-toggle-right" }),
                    _c("span", [_vm._v("Siguiente")])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaTransportistas",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { filterStatus: false, tipoFiltro: "T" },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            scrollable: "",
            width: "70%",
            height: "auto",
            name: "persona"
          }
        },
        [
          _c("persona", {
            attrs: {
              tipoFiltro: "T",
              numeroIdentificacion: _vm.numero_identificacion,
              searchButton: false
            },
            on: { saved: _vm.savedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaGuiasRemision",
            height: "auto",
            width: "70%",
            scrollable: ""
          }
        },
        [
          _c("lista-comprobantes", {
            attrs: { tipoComprobante: _vm.codigoGuiaRemision },
            on: { selected: _vm.selectedComprobante }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "imprimir",
            height: "auto",
            scrollable: ""
          }
        },
        [_c("imprimir", { attrs: { id_comprobante: _vm.id_comprobante } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Detalle de la guía de remisión")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-434cd733", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434cd733","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/GuiaRemision.vue
// module id = 435
// module chunks = 0